import { CommonModule } from '@angular/common';
import { Component, OnInit} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NavController, NavParams, ModalController, IonicModule } from '@ionic/angular';
import { ToastController } from '@ionic/angular/standalone';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { isBefore, isEqual } from 'date-fns';
import { ProverDatepickerComponent } from 'src/app/components/prover-datepicker/prover-datepicker';
import { NomenclaturaPipe } from 'src/app/pipes/nomenclatura/nomenclatura';
import { ConfigProvider } from 'src/app/services/config/config';
import { UserProvider } from 'src/app/services/user/user';

@Component({
  selector: 'app-oracao-adm-filtro',
  templateUrl: './oracao-adm-filtro.page.html',
  styleUrls: ['./oracao-adm-filtro.page.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    NomenclaturaPipe,
    TranslateModule,
    ProverDatepickerComponent
  ],
})
export class OracaoAdmFiltroPage implements OnInit {
  filtro: any = {};
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public modalCtrl: ModalController,
    public configProvider: ConfigProvider,
    public userProvider: UserProvider,
    public toastCtrl: ToastController,
    public translate: TranslateService
    
  ) {
    this.filtro = this.navParams.get('filtro');
  }

  ngOnInit() {
  }

  async filtrar() {
    let filter: any = {};

    const result =
      isBefore(new Date(this.filtro.dtInicial), new Date(this.filtro.dtFinal)) ||
      isEqual(new Date(this.filtro.dtInicial), new Date(this.filtro.dtFinal));
    
      if (!result) {
        const toast = await this.toastCtrl.create({
          message: this.translate.instant("As datas informadas não atendem aos critérios de validação."),
          duration: 3000,
      });
    
      toast.present();
      return;
    }

    if (this.filtro.publico && !this.filtro.privado) {
      filter.privacidade = 'PUBLICO';
    } else if (!this.filtro.publico && this.filtro.privado) {
      filter.privacidade = 'PRIVADO';
    }

    if (this.filtro.respondido && !this.filtro.naoRespondido) {
      filter.status = '2';
    } else if (!this.filtro.respondido && this.filtro.naoRespondido) {
      filter.status = '1';
    }

    if (this.filtro.liberado && !this.filtro.naoLiberado) {
      filter.liberado = '1';
    } else if (!this.filtro.liberado && this.filtro.naoLiberado) {
      filter.liberado = '0';
    }

    if(this.filtro.oracao && !this.filtro.testemunho) {
      filter.isTestemunho = '1';
    } else if (!this.filtro.oracao && this.filtro.testemunho) {
      filter.isTestemunho = '2';
    }

    if (this.filtro.dtInicial) {
      filter.dtI = this.filtro.dtInicial;
    }
    if (this.filtro.dtFinal) {
      filter.dtF = this.filtro.dtFinal;
    }

    if (this.filtro.dtFinal) {
      filter.dtF = this.filtro.dtFinal;
    }

    filter.ordenacao = this.filtro.ordenacao;

    this.modalCtrl.dismiss({ 'filtroTela': this.filtro, 'filtro': filter });

  }

  public closeModal() {
    this.modalCtrl.dismiss(false);
  }

}
